import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = {
  class: "df df-around vertical",
  style: {"margin-top":"20px"}
}

import { pieChartOption } from '@/views/afterSaleRepair/pc/statistics';
import pieChart from './pieChart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics',
  props: {
    rectificationInformation: Object,
    columns: Array,
},
  setup(__props) {

const chartOption = pieChartOption();

const props = __props

const setChart = () => {

    const chartDataList = [];

    const color = ['#48c8ac', '#feb348', '#fe7b48', '#5fb6ff', '#3787ff', '#4165ff', '#267d6a', '#c37301'];
    props.rectificationInformation.data.forEach((item, index) => {
        if (item.problemType === '合计') return;
        chartDataList.push({
            name: item.problemType,
            value: item.total,
            itemStyle: {
                color: color[index]
            },
            label: {
                show: item.total > 0,
            },
            labelLine: {
                show: item.total > 0,
            }
        });
    });

    chartOption.series[0].data = chartDataList;

};

setChart();




return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.rectificationInformation.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        pagination: false,
        columns: props.columns,
        "data-source": __props.rectificationInformation.data,
        bordered: "",
        style: {"width":"600px","margin-bottom":"20px"}
      }, null, 8, ["columns", "data-source"]),
      _createVNode(pieChart, { option: _unref(chartOption) }, null, 8, ["option"])
    ])
  ], 64))
}
}

})